module.exports = __webpack_public_path__ + "img/email.951e5dd4.jpg";